import {axiosDefault} from '../lib/network';

export const sendPasswordResetLink = (email, sourceApp) => {
  return axiosDefault.post(`/v2/users/send-password-reset-link`, {email, sourceApp}).then(function (response) {
    return response.data;
  });
};
